import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
export const _frontmatter = {
  "title": "AI fürs Smarthome",
  "path": "/Frequently_Asked_Question/UHD_AI_for_your_Smarthome/",
  "dateChanged": "2025-11-25",
  "author": "Mike Polinowski",
  "excerpt": "Ab sofort wird es möglich sein, die AI Ihrer 2K+/WQHD 4K/UHD Kamera direkt in Drittanbieter Software zu nutzen, um Personen, Autos, Tiere usw. zu erkennen!",
  "image": "../FAQ_SearchThumb.png",
  "social": "/images/Search/FAQ_SearchThumb.webp",
  "toc": "/images/Search/TOC_Icons/Wiki_Tiles_FAQs_white.webp",
  "chapter": "FAQs",
  "faq": "WQHD & UHD Cameras"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <SEOHelmet title='AI fürs Smarthome' dateChanged='2025-11-25' author='Mike Polinowski' tag='INSTAR IP Camera' description='Ab sofort wird es möglich sein, die AI Ihrer 2K+/WQHD 4K/UHD Kamera direkt in Drittanbieter Software zu nutzen, um Personen, Autos, Tiere usw. zu erkennen!' image='/images/Search/FAQ_SearchThumb.png' twitter='/images/Search/FAQ_SearchThumb.webp' location={props.location.pathname} mdxType="SEOHelmet" />
    <BreadCrumbs locationBC={props.location} locationDE={props.location.pathname} locationEN='/en/Frequently_Asked_Question/UHD_AI_for_your_Smarthome/' locationFR='/fr/Frequently_Asked_Question/UHD_AI_for_your_Smarthome/' crumbLabel="FAQs" mdxType="BreadCrumbs" />
    <h1 {...{
      "id": "ai-fürs-smarthome",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h1" {...{
        "href": "#ai-f%C3%BCrs-smarthome",
        "aria-label": "ai fürs smarthome permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`AI fürs Smarthome`}</h1>
    <p>{`Ab sofort wird es möglich sein, die AI Ihrer 2K+/WQHD 4K/UHD Kamera direkt in Drittanbieter Software zu nutzen, um Personen, Autos, Tiere usw. zu erkennen! Für eine Übersicht aller Objekt-Klassen siehe auch - `}<a parentName="p" {...{
        "href": "https://forum.instar.com/t/erweiterte-ai-objekterkennung-fuer-2k-wqhd-kameras/30548"
      }}>{`AI Objekterkennung`}</a></p>
    <h2 {...{
      "id": "alarm-objekterkennung",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#alarm-objekterkennung",
        "aria-label": "alarm objekterkennung permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Alarm Objekterkennung`}</h2>
    <p>{`Bisher war die Objekterkennung nur indirekt nutzbar. Im `}<a parentName="p" {...{
        "href": "/de/Web_User_Interface/1440p_Serie/Alarm/Aktionen/"
      }}>{`Alarm/Aktionen Menü`}</a>{` konnte das AI Modell als Filter nutzen, um Alarme ohne Personen/Autos/Tiere als Fehlalarme zu verwerfen. Das `}<a parentName="p" {...{
        "href": "/de/Web_User_Interface/1440p_Serie/Alarm/Objekt_Erkennung/"
      }}>{`Alarm/Objekterkennung Menü`}</a>{` ermöglichte dann noch das Feinjustieren durch das Einstellen einer minimalen und maximalen Grösse, die man für das Objekt erwartet, und eines Schwellwertes an Sicherheit, die die Erkennung haben musste.`}</p>
    <h3 {...{
      "id": "analyse-von-fehlerkennungen",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#analyse-von-fehlerkennungen",
        "aria-label": "analyse von fehlerkennungen permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Analyse von Fehlerkennungen`}</h3>
    <p>{`Bei Fehlerkennungen durch das AI Modell war es bisher schwierig die Ursache ausfindig zu machen, bzw. einen minimalen Schwellwert / Objektgrösse zu ermitteln, mit dem die Erkennung ausgeschlossen werden kann.`}</p>
    <p>{`Durch die direkte Anfrage an das Modell erhält man jetzt direkt die Rohdaten mit der Objektklasse, der Sicherheit mit der die Vorhersage erfolgte und die Position im Bild. Dies kann mit dem folgenden `}<a parentName="p" {...{
        "href": "/de/1440p_Serie_CGI_Befehle/"
      }}>{`CGI Befehl`}</a>{` gemacht werden:`}</p>
    <ul>
      <li parentName="ul">
        <p parentName="li"><code parentName="p" {...{
            "className": "language-text"
          }}>{`param.cgi?cmd=getmodelprediction&count=1&model=movingobjects`}</code></p>
        <ul parentName="li">
          <li parentName="ul"><code parentName="li" {...{
              "className": "language-text"
            }}>{`count`}</code>{`: Zum angeben der Anzahl an Erkennungen die man erwartet. Wenn sich mehr als ein Objekt im Kamerbild aufhalten muss dieser entsprechend angepasst werden, um alle Erkennungen zu erhalten. Wenn weniger Objekte erkannt werden als mit diesem Wert angegeben, werden die weiteren mit „Nullwerten“ gefüllt. Dies erleichtert die Einbindung in Drittanbieter Systeme.`}</li>
          <li parentName="ul"><code parentName="li" {...{
              "className": "language-text"
            }}>{`model`}</code>{`: In Zunkunft werden unterschiedliche AI Modelle auf der Kamera zur Verfügung stehen. Aktuell hat man nur das movingobjects, das auch für die Alarm Objekterkennung verwendet wird.`}</li>
        </ul>
      </li>
    </ul>
    <p>{`Die Rückgabe dieses Befehls schaut dann z.B. so aus:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "text"
    }}><pre parentName="div" {...{
        "className": "language-text"
      }}><code parentName="pre" {...{
          "className": "language-text"
        }}>{`cmd="getmodelprediction";
objects="[{"class": "person", "confidence": 0.78, "x": 1344, "y": 240, "w": 640, "h": 704}]";
response="200";`}</code></pre></div>
    <p>{`Hier ist die Kamera sich 78% eine Person im Bildbereich erkannt zu haben dessen obere Ecke bei dem Pixel x=344, y=240 beginnt (diese Zahlen beziehen sich auf die Auflösung des Kamerabildes - x=0, y=0 wäre z.B. die linke, obere Ecke des Kamerabildes) und eine Breite/Höhe von 640 / 704 Pixel hat.`}</p>
    <p>{`Wenn man an dieser Stellen einen Weihnachtsmann aufgestellt hat, hat man also schon mal einen Ansatz, was die Fehlerkennung auslösen könnte.`}</p>
    <p>{`Oft sind es Pflanzen, dekorative Beleuchtung o.ä., was eine Fehlerkennung auslöst. Wenn man diese mit einer `}<a parentName="p" {...{
        "href": "/de/Web_User_Interface/1440p_Serie/Multimedia/Privat_Maske/"
      }}>{`Privatsphäre Maske`}</a>{` abdeckt ist das Problem schon gelöst! In den meisten Fällen reicht es schon einfach einen dünnen Balken durch die Mitte des Objektes zu ziehen. Einfach anpassen, eine neue Vorhersage vom Modell anfragen und wiederholen, bis die Sicherheit der Erkennung bis unter den Erkennungsschwellwert abgefallen ist.
Smarthome`}</p>
    <p>{`Die Einbindung ins Smarthome über den Befehl oben ist analog zum `}<a parentName="p" {...{
        "href": "/de/Frequently_Asked_Question/WQHD_MQTTv5_Alarmserver_Testing/"
      }}>{`Erweiterten HTTP Alarmserver`}</a>{` (Beispiel: `}<a parentName="p" {...{
        "href": "/de/Frequently_Asked_Question/WQHD_MQTTv5_Alarmserver_APIv2_NodeRED/"
      }}>{`Node-RED`}</a>{`) möglich. Komfortabler geht das ganze dann über die MQTT Schnittstelle mit dem MQTT Topic und Payload:`}</p>
    <ul>
      <li parentName="ul"><code parentName="li" {...{
          "className": "language-text"
        }}>{`alarm/triggered/objects/manual`}</code>{`: `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`{"val":"movingobjects"}`}</code></li>
    </ul>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "920px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/de/static/bb86ef0894ee55ee7af21f390e3a01fc/8ea22/AI_for_your_Smarthome_01.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "63.47826086956522%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAANCAIAAAAmMtkJAAAACXBIWXMAAAsTAAALEwEAmpwYAAACVUlEQVQoz2WR607bQBCF/SKUQGLnZu/Gdnad9WXteO31NVfTJCROCb2oUImWH32BPkHfA1GBgAdsHaq2KkefRkeaGY10RgCqKfeI1OmLbU1s62Jblzq62Na6kGiINrtIamvNjv7Mc6uaafdbXSyEr++zzeN4+8iKu7x8mO+e8s3DM/Hqfrx9dMe3JL0xsxuS3rjj23h5505+nF8/zXb3wuTk64BuDWeD7ZLQrem9IW6FuYfQrcc/xuMvPL8K86todJWMPwfJZT77FGYXwnSS2BbCCKI+0NQuUFp/gKClyJJLB/N5PpumxTyfTuLxKIpCN2DUc4lQFCfT6dz3WRBy07RVVev1/gKhattOlo3iOPFZenq6ef/hkk++5YvvdDgR0jTN89y2bcdxLMvqvdDAMPQ+0PSurgOEej0VdGQoKyohZrW8Wq3CMPBclxACIYAA/K6gEjZQp1tviIdSs9YQDxviK1E6EKUDY4AE32fL5WkSp45N+31sGAOEDIQwwhhhA+PBgBiyIjVbx81WvdWu2JsGxkjwWbRcX+fTi9HsIsre8uw8iHcsOmPxWZjsePqOemGneyxKR1LzSJRqolSTmrV64yBJYmGxWBTzGfOHnIeM+RAoAMigqpVRFNk0ie1YlmNatukNXd8fep479L2yLIWyLIuiSJKEc25ZlmEY/6YFIbRtJ89y3/dd12OM8ZAHQcgYW6/XAmOMUmpbtmWamqapqvpf2oSQNE2TvaI4CoOAUooxXi6XgizLiqLscwUQwpevIoRUBzlP0zQMApe6lFJCyK/ln8JNwXwZltBPAAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/bb86ef0894ee55ee7af21f390e3a01fc/e4706/AI_for_your_Smarthome_01.avif 230w", "/de/static/bb86ef0894ee55ee7af21f390e3a01fc/d1af7/AI_for_your_Smarthome_01.avif 460w", "/de/static/bb86ef0894ee55ee7af21f390e3a01fc/7f308/AI_for_your_Smarthome_01.avif 920w", "/de/static/bb86ef0894ee55ee7af21f390e3a01fc/fab00/AI_for_your_Smarthome_01.avif 1023w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/de/static/bb86ef0894ee55ee7af21f390e3a01fc/a0b58/AI_for_your_Smarthome_01.webp 230w", "/de/static/bb86ef0894ee55ee7af21f390e3a01fc/bc10c/AI_for_your_Smarthome_01.webp 460w", "/de/static/bb86ef0894ee55ee7af21f390e3a01fc/966d8/AI_for_your_Smarthome_01.webp 920w", "/de/static/bb86ef0894ee55ee7af21f390e3a01fc/da35d/AI_for_your_Smarthome_01.webp 1023w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/bb86ef0894ee55ee7af21f390e3a01fc/81c8e/AI_for_your_Smarthome_01.png 230w", "/de/static/bb86ef0894ee55ee7af21f390e3a01fc/08a84/AI_for_your_Smarthome_01.png 460w", "/de/static/bb86ef0894ee55ee7af21f390e3a01fc/c0255/AI_for_your_Smarthome_01.png 920w", "/de/static/bb86ef0894ee55ee7af21f390e3a01fc/8ea22/AI_for_your_Smarthome_01.png 1023w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/de/static/bb86ef0894ee55ee7af21f390e3a01fc/c0255/AI_for_your_Smarthome_01.png",
              "alt": "MQTT Explorer",
              "title": "MQTT Explorer",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`Die Einbindung erfolgt dann ebenfalls wie beim Erweiterten MQTT Alarmserver bereits erklärt.`}</p>
    <p>{`Diese Funktion ermöglicht es bei frei definierbaren Ereignissen aus dem Smarthome eine AI Anfrage an die Kamera auszulösen und nach dem Auffinden des gewünschten Objekts eine Aktion zu triggern.`}</p>
    <p>{`Siehe auch `}<a parentName="p" {...{
        "href": "/de/Frequently_Asked_Question/UHD_Home_Assistant_MQTT_Discovery/"
      }}>{`Home Assistant MQTT Auto-Discovery`}</a>{` oder `}<a parentName="p" {...{
        "href": "/de/Frequently_Asked_Question/UHD_OpenHAB_MQTT_Discovery/"
      }}>{`OpenHAB MQTT Auto-Discovery`}</a>{` für eine vollständig automatische Einbindung in Ihr Smarthome!`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/de/FAQs/"
        }}>{`FAQs`}</a>
        <ul parentName="li">
          <li parentName="ul"><a parentName="li" {...{
              "href": "/de/FAQs/IN-9420WQHD/"
            }}>{`IN-9420 WQHD`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/de/FAQs/IN-9408WQHD/"
            }}>{`IN-9408 WQHD`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/de/FAQs/IN-8415WQHD/"
            }}>{`IN-8415 WQHD`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/de/FAQs/IN-8403WQHD/"
            }}>{`IN-8403 WQHD`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/de/FAQs/IN-8401WQHD/"
            }}>{`IN-8401 WQHD`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/de/FAQs/IN-9020FHD/"
            }}>{`IN-9020 Full HD`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/de/FAQs/IN-9010FHD/"
            }}>{`IN-9010 Full HD`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/de/FAQs/IN-9008FHD/"
            }}>{`IN-9008 Full HD`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/de/FAQs/IN-8015FHD/"
            }}>{`IN-8015 Full HD`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/de/FAQs/IN-8003FHD/"
            }}>{`IN-8003 Full HD`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/de/FAQs/IN-8001FHD/"
            }}>{`IN-8001 Full HD`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/de/FAQs/IN-7011HD/"
            }}>{`IN-7011 HD`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/de/FAQs/IN-6014HD/"
            }}>{`IN-6014 HD`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/de/FAQs/IN-6012HD/"
            }}>{`IN-6012 HD`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/de/FAQs/IN-6001HD/"
            }}>{`IN-6001 HD`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/de/FAQs/IN-5907HD/"
            }}>{`IN-5907 HD`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/de/FAQs/IN-5905HD/"
            }}>{`IN-5905 HD`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/de/FAQs/VGA_Series/"
            }}>{`VGA Series`}</a></li>
        </ul>
      </li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      